import React, {Fragment} from "react";

import {Recent} from "./Recent";
import {Categories} from "./Categories";
import {Tags} from "./Tags";

export const Left = ({from, city, path, category, author}) => {

    return (
        <Fragment>
            <Recent
                from={from}
                city={city}
                path={path}
                category={category}
                author={author}
            />
            <Categories
                from={from}
                city={city}
                path={path}
                author={author}
            />
            <Tags
                city={city}
            />
        </Fragment>
    );
};
